import ArtileEl, {
  White,
  Desc,
  Header,
  CustomImage,
  Quote,
  Author,
  QuoteEl,
} from "../../components/Elements/ArticleEl";

import { ArticleElBackgroundWrapper } from "../../components/Elements/ArticleElBackgroundWrapper";

import VideoElement from "../../components/Elements/VideoElement";
import ImageSlider from "../../components/Elements/ImageSlider";
import QuoteSliderSlick from "../../components/Elements/QuoteSliderSlick";
import BtnParallax from "../../components/Elements/BtnParallax";

import { isMobile } from "../../hooks/isMobile";

import cases from "../cases/cases.json";

const componentName = "DasHandwerkOnlyUp";

const shorthand = cases.find(
  (x) => x.component == componentName
).shorthand;

if (typeof shorthand == "undefined")
  console.error(
    "Component can't find shorthand: " +
      componentName
  );

export default (handleVideoModalOpen) => (
  <>
    <ArticleElBackgroundWrapper
      id={shorthand}
      variant={"article_top"}
    >
      <ArtileEl
        type={"text-right-half"}
        size={"xl"}
        center
        style={{
          paddingTop: 0,
          paddingBottom: 0,
          margin: 0,
        }}
      >
        <Header customType="header">
          <div className="section-hero">
            <div className="section-title-sub grad-txt">
              Only Up - Zum Monument
            </div>
          </div>
        </Header>

        <Desc customType="desc">
          <White>
            A high-stakes Fortnite ONLY UP challenge{" "}
          </White>{" "}
          built for Das Handwerk, putting players’
          speed, precision, and persistence to the
          test{" "}
          <White>
            - with rankings and prizes on the line.
          </White>
        </Desc>

        <CustomImage
          maxWidth={
            isMobile
              ? "100%"
              : "25%"
          }
          customType="image"
          round
          flex
          backgroundSize={"cover"}
          backgroundPosition={"center"}
          ar={
            isMobile
              ? 16 / 9
              : 1
          }
          outline={
            isMobile
              ? false
              : true
          }
          src={
            isMobile
              ? `/img/cases/${shorthand}/poster/das-handwerk-only-up-zum-monument-poster-landscape-1600p.jpg`
              : `/img/cases/${shorthand}/image/img_01.jpg`
          }
        />
      </ArtileEl>
    </ArticleElBackgroundWrapper>

    <QuoteSliderSlick>
      <QuoteEl
        size="s"
        no-p-quote
        no-p
        fullfill
      >
        <Quote customType="quote">
          "Gaming isn’t just another media channel
          for Das Handwerk. It is a world where
          exactly the things that the skilled trades
          stand for matter: developing skills,
          solving problems, and ultimately seeing
          what you have created yourself."
        </Quote>

        <Author customType="author">
          <White>
            - Mike Schleiermacher,{" "}
            <i>
              Innovation Director Carl Nann
            </i>
          </White>
        </Author>
      </QuoteEl>

      <QuoteEl
        size="s"
        no-p-quote
        no-p
        fullfill
      >
        <Quote customType="quote">
          “Skill, timing, persistence, getting better
          with every run. That’s where Fortnite and
          Handwerk naturally meet.”
        </Quote>

        <Author customType="author">
          <White>
            - Christine Niemann,{" "}
            <i>
              Co-Founder Stunning Studio
            </i>
          </White>
        </Author>
      </QuoteEl>

      <QuoteEl
        size="s"
        no-p-quote
        no-p
        fullfill
      >
        <Quote customType="quote">
          “I love it soooo much.”
        </Quote>

        <Author customType="author">
          <White>
            - Noah N.,{" "}
            <i>
              9-year-old Fortnite veteran
            </i>
          </White>
        </Author>
      </QuoteEl>
    </QuoteSliderSlick>

    <div className="section-div">
      <div
        className="section-img"
        style={{
          pointerEvents: "all",
          width: "100%",
          marginTop: 0,
        }}
      >
        <VideoElement
          aspectratio={
            isMobile
              ? 3 / 4
              : 2.35 / 1
          }
          round
          shorthand={"handwerk-preview"}
        />

        <div className="section-vid-overlay-play">
          <div
            className="vid-overlay-flex-center"
            style={{
              paddingBottom: "20px",
            }}
          >
            <BtnParallax
              landing
              filled
              text={"Watch Trailer"}
              filmicon
              addclass={
                "btn-parallax-sol-pseudo"
              }
              small
              onclick={() => {
                handleVideoModalOpen(
                  true,
                  false
                );
              }}
            />
          </div>
        </div>
      </div>
    </div>

    <div className="section-div">
      <div
        className="section-content bigger left"
        style={{
          flexDirection: "column",
        }}
      >
        <div className="section-hero">
          <div className="section-title-sub grad-txt">
            Where Gaming Skill Meets Real-World Craft
          </div>
        </div>

        <div className="section-description">
          <White>
            Handwerk Heroes 'ONLY UP - ZUM MONUMENT'
            turns Fortnite into a recruiting
            experience for the next generation of
            skilled talent.
          </White>{" "}
          Players climb, adapt and master a world
          built around the same things that define
          great craftsmanship:{" "}
          <White>
            precision, persistence, problem-solving
            and the passion to keep getting better.
          </White>{" "}
          Instead of simply talking about careers,
          we made the mindset behind them playable.
        </div>
      </div>
    </div>

    <div className="section-div">
      <ImageSlider
        mode="gallery"
        data={[
          `/img/cases/${shorthand}/image/slider-stills/Still-01.jpg`,
          `/img/cases/${shorthand}/image/slider-stills/Still-08.jpg`,
          `/img/cases/${shorthand}/image/slider-stills/Still-02.jpg`,
          `/img/cases/${shorthand}/image/slider-stills/Still-04.jpg`,
          `/img/cases/${shorthand}/image/slider-stills/Still-03.jpg`,
        
          `/img/cases/${shorthand}/image/slider-stills/Still-05.jpg`,
          `/img/cases/${shorthand}/image/slider-stills/Still-06.jpg`,
          `/img/cases/${shorthand}/image/slider-stills/Still-07.jpg`,
         
        ]}
      />
    </div>

    <div className="section-div">
      <div
        className="section-content bigger left"
        style={{
          flexDirection: "column",
        }}
      >
        <div className="section-hero">
          <div className="section-title-sub grad-txt">
            The Idea
          </div>
        </div>

        <div className="section-description">
          Handwerk Heroes brings the{" "}
          <White>
            spirit of skilled craftsmanship into
            Fortnite
          </White>{" "}
          - turning precision, persistence, and
          perfect timing into a competitive gaming
          challenge.
          <br />
          <br />
          At the heart of the campaign is a{" "}
          <White>
            custom-built ONLY UP island
          </White>
          , packed with tricky jumps, unforgiving
          passages, and plenty of vertical meters to
          conquer.
          <br />
          <br />
          Players are challenged to{" "}
          <White>
            climb higher, improve their best time,
            and fight for the top of the leaderboard
          </White>{" "}
          - creating a format built around constant
          retries, personal progression, and
          competition for prizes.
          <br />
          <br />
          The challenge kicked off with a{" "}
          <White>
            live Twitch release event featuring four
            gaming creators
          </White>
          , launching a four-week qualification
          phase and giving the community their
          chance to prove what they’re made of.
        </div>
      </div>
    </div>

    <ArticleElBackgroundWrapper
      id={"slider" + shorthand}
      variant={"article_slider"}
    >
      <div className="section-div no-p">
        <ImageSlider
          data={[
            `/img/cases/${shorthand}/image/slider-VARION.jpg`,
            `/img/cases/${shorthand}/image/slider-LOSTKITTN.jpg`,
            `/img/cases/${shorthand}/image/slider-KADDITV.jpg`,
            `/img/cases/${shorthand}/image/slider-FAISTER.jpg`,
          ]}
        />
      </div>
    </ArticleElBackgroundWrapper>

    <div className="section-div">
      <div
        className="section-content bigger left"
        style={{
          flexDirection: "column",
        }}
      >
        <div className="section-hero">
          <div className="section-title-sub grad-txt">
            Built to Be Mastered
          </div>
        </div>

        <div className="section-description">
          <White>
            A completely custom-built level transforms
            the world of Das Handwerk into an oversized
            Fortnite playground.
          </White>{" "}
          Players climb across a colossal hammer, saw,
          whisk and even through a computer built around
          its PCB — mastering one challenge after
          another on the way to a single goal:{" "}
          <White>
            the Monument, crowned by the huge magenta
            Handwerk thumb.
          </White>{" "}
          Every obstacle turns craftsmanship into
          gameplay, rewarding timing, precision and
          skill.
        </div>
      </div>
    </div>

    <div className="section-div">
      <div
        className="section-content bigger left"
        style={{
          flexDirection: "column",
        }}
      >
        <div className="section-hero">
          <div className="section-title-sub grad-txt">
            30+ Assets. One Handwerk World.
          </div>
        </div>

        <div className="section-description">
          <White>
            More than 30 bespoke brand assets were
            created from scratch to feel native to
            Fortnite.
          </White>{" "}
          Tools, machines, materials and familiar
          symbols of the trades seamlessly merge with
          the game's art direction,{" "}
          <White>
            turning the identity of Das Handwerk into
            an actual part of the experience.
          </White>{" "}
          Not advertising placed inside a game, but a
          world players want to explore, recognize and
          master.
        </div>
      </div>
    </div>

    <div className="section-div">
      <div
        className="section-content bigger left"
        style={{
          flexDirection: "column",
        }}
      >
        <div className="section-hero">
          <div className="section-title-sub grad-txt">
            From Play to Possibility
          </div>
        </div>

        <div className="section-description">
          <White>
            Built to work across solo play, live
            streams, tournaments and physical events,
          </White>{" "}
          Handwerk Heroes connects with young people
          wherever gaming happens. From playing the
          level at home to competing online or
          discovering it at conventions,{" "}
          <White>
            every format creates a new opportunity to
            discover the world of craftsmanship.
          </White>{" "}
          Using the excitement of gaming to spark
          curiosity for real skills, real trades and
          real career paths.
        </div>
      </div>
    </div>

    <div className="section-div">
      <div className="section-content bigger left credits">
        <div className="credit-headline">
          <div className="section-title-sub">
            Credits
          </div>

          <div className="credit-divider"></div>
        </div>

        <div className="credits">
          <div className="credits-column">
            <div className="credit-block">
              <div className="credits-title">
                Client
              </div>

              <div className="credits-name">
                Das Handwerk
              </div>
            </div>
          </div>

          <div className="credits-column">
            <div className="credit-block">
              <div className="credits-title">
                Agency
              </div>

              <div className="credits-name">
                CarlNann &amp; Strafejump
              </div>
            </div>
          </div>

          <div className="credits-column">
            <div className="credit-block">
              <div className="credits-title">
                Production Company
              </div>

              <div className="credits-name">
                Stunning Studio
              </div>
            </div>
          </div>

          <div className="credits-column">
            <div className="credit-block">
              <div className="credits-title">
                Creators
              </div>

              <div className="credits-name">
                Varion, LostKittn, KaddiTV, Faister
              </div>
            </div>
          </div>
        </div>

        <div className="credit-headline"></div>
      </div>
    </div>
  </>
);